<mat-form-field appearance="outline" subscriptSizing="dynamic" class="field">
  <mat-label>{{ label() }}</mat-label>
  <mat-chip-grid #grid [attr.aria-label]="label()" [disabled]="disabled()">
    @for (chosen of value(); track key()(chosen)) {
      <mat-chip-row (removed)="remove(chosen)">
        {{ display()(chosen) }}
        <button type="button" matChipRemove [attr.aria-label]="`Odobrať ${display()(chosen)}`">
          <mat-icon>cancel</mat-icon>
        </button>
      </mat-chip-row>
    }
    <input
      #input
      [placeholder]="placeholder()"
      [value]="query()"
      (input)="onInput($event)"
      (blur)="touch.emit()"
      [matChipInputFor]="grid"
      [matAutocomplete]="auto"
      data-testid="search-or-create-input"
    />
  </mat-chip-grid>
</mat-form-field>

<!-- The options are written out in both branches: a mat-option stamped from a template declared elsewhere is not
     found by the autocomplete's content query, and would not see its optgroup. -->
<mat-autocomplete #auto="matAutocomplete" (optionSelected)="choose($event)">
  @if (createLabel()) {
    <mat-option [value]="createValue" class="create" data-testid="search-or-create-create">
      <span class="create__text">
        <mat-icon aria-hidden="true">{{ createIcon() }}</mat-icon>
        {{ createLabel() }}{{ trimmedQuery() ? ` „${trimmedQuery()}“` : '' }}
      </span>
    </mat-option>
  }
  @for (group of groups(); track $index) {
    @if (group.label) {
      <mat-optgroup [label]="group.label">
        @for (option of group.options; track key()(option.value)) {
          <mat-option [value]="option.value" [disabled]="!!option.disabledReason">
            <span class="option">
              <span>{{ option.label }}</span>
              @if (option.detail) {
                <span class="option__detail">{{ option.detail }}</span>
              }
              @if (option.disabledReason) {
                <span class="option__reason">{{ option.disabledReason }}</span>
              }
            </span>
          </mat-option>
        }
      </mat-optgroup>
    } @else {
      @for (option of group.options; track key()(option.value)) {
        <mat-option [value]="option.value" [disabled]="!!option.disabledReason">
          <span class="option">
            <span>{{ option.label }}</span>
            @if (option.detail) {
              <span class="option__detail">{{ option.detail }}</span>
            }
            @if (option.disabledReason) {
              <span class="option__reason">{{ option.disabledReason }}</span>
            }
          </span>
        </mat-option>
      }
    }
  }
</mat-autocomplete>
